/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-24 14:57:18
 * @FilePath: /vise/packages/app-share/src/composable/use-initialize-share-data/index.ts
 */
import { watch, computed } from 'vue';
import { report } from '@/libs/report';
import { useStore, MutationTypes } from '@/store/index';
import { ShareIns } from '@/types/share';
import { loadWslShareAsync } from '@/utils/load-wslib';
import { formatFeedShareInfo, setShareHandler, setQqShareBtnHandler, replaceFeedId } from '@/utils/share';

export default function useInitializeShareData() {
  const { state, commit } = useStore();
  let shareIns: null| ShareIns = null;
  return async () => {
    const activeIndex = computed(() => state.activeIndex);
    const feedsList = computed(() => state.feedsList);
    const activeFeed = feedsList.value[activeIndex.value];
    const wsShare = await loadWslShareAsync();
    // 是否存在必要的数据
    if (!activeFeed || !wsShare) return;
    const shareInfo = formatFeedShareInfo(activeFeed.shareInfo);
    shareIns = await wsShare.init<ShareIns>({
      shareInfo: wsShare.formatFromWeishi(shareInfo),
      callback(_, client: string) {
        report(`video.share.${client}.click`);
      },
    });
    // 存储shareIns以便业务组件调用该方法
    commit({
      type: MutationTypes.SET_SHARE_UI,
      value: shareIns.ui,
    });
    // 当前视频切换或者feedlist改变时
    watch(activeIndex, () => {
      setShareHandler(activeFeed);
    });
    watch(feedsList, () => {
      setShareHandler(activeFeed);
    });
    // QQ和微信sdk，可能需要一点延迟，定时器做兼容
    setTimeout(() => {
      // share组件不支持在微信或qq中对分享到不同平台配置不同的文案，需要手动覆盖掉
      setShareHandler(activeFeed);
      setQqShareBtnHandler((index: number) => {
        if (!shareIns || !activeFeed) return;
        const { title, desc, image_url: imgUrl } = activeFeed.shareInfo.bodyMap[index];
        shareIns.shareInfo = {
          ...shareIns.shareInfo,
          title,
          desc,
          link: replaceFeedId(activeFeed),
          imgUrl,
        };
      });
    }, 200);
  };
};
